// extracted by mini-css-extract-plugin
export default {"label":"ImageInput_label__-Od9L","labelWithIcon":"ImageInput_labelWithIcon__rvhPe"};